/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Partnerships_CtaInputs */

const en_directory_resources_partnerships_cta = /** @type {(inputs: Directory_Resources_Partnerships_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discuss a partnership`)
};

const zh_directory_resources_partnerships_cta = /** @type {(inputs: Directory_Resources_Partnerships_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`洽谈合作`)
};

/**
* | output |
* | --- |
* | "Discuss a partnership" |
*
* @param {Directory_Resources_Partnerships_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_partnerships_cta = /** @type {((inputs?: Directory_Resources_Partnerships_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Partnerships_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_partnerships_cta(inputs)
	return zh_directory_resources_partnerships_cta(inputs)
});
export { directory_resources_partnerships_cta as "directory.resources.partnerships.cta" }